
// --- Browser Details --- //
function getBroswerDetails() {
  //Checking the user's OS and Browser
  if ((navigator.userAgent).includes("Android")) {
    document.querySelector("html").classList.add("android");
  } else if ((navigator.userAgent).includes("Mac")) {
    document.querySelector("html").classList.add("mac");
  } else {
    document.querySelector("html").classList.add("windows");
  }
  //-- Browser --//
  var isOpera = (!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
  var isFirefox = typeof InstallTrigger !== 'undefined';
  var isSafari = /constructor/i.test(window.HTMLElement) || (function(p) {
    return p.toString() === "[object SafariRemoteNotification]";
  })(!window['safari'] || (typeof safari !== 'undefined' && window['safari'].pushNotification));
  var isIE = /*@cc_on!@*/ false || !!document.documentMode;
  var isEdge = !isIE && !!window.StyleMedia;
  var isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);
  var isEdgeChromium = isChrome && (navigator.userAgent.indexOf("Edg") != -1);
  var isBlink = (isChrome || isOpera) && !!window.CSS;
  if (isFirefox) {
    document.querySelector("html").classList.add("isFirefox")
  } else if (isChrome) {
    document.querySelector("html").classList.add("isChrome")
  } else if (isSafari) {
    document.querySelector("html").classList.add("isSafari")
  } else if (isOpera) {
    document.querySelector("html").classList.add("isOpera")
  } else if (isIE) {
    document.querySelector("html").classList.add("isIE")
  } else if (isEdge) {
    document.querySelector("html").classList.add("isEdge")
  } else if (isEdgeChromium) {
    document.querySelector("html").classList.add("isEdgeChromium")
  } else {
    document.querySelector("html").classList.add("isBlink")
  }
}
getBroswerDetails();



const menubaar = document.querySelector('.header__icon--menu');
const megamenu = document.querySelector(".megamenu_main_wrapper");
menubaar.addEventListener('click', (e) => {
  megamenu.classList.toggle("active");
  menubaar.classList.toggle("active");
});

var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

function cartPopupPos() {
  var cartPopup = document.querySelector('.cart-popup');
  var headerIconCart = document.querySelector('.header__icon--cart');

  if (cartPopup && window.innerWidth >= 768) {
      var l = headerIconCart.offsetLeft - cartPopup.offsetWidth + 20;
      var t = document.querySelector('header').offsetHeight;

      cartPopup.style.left = l + 'px';
      cartPopup.style.top = t + 'px';
  }
}

cartPopupPos();

// Subscription Icon
if (document.querySelector(".subscription-slider")) {
  var subscriptionSlider = new Flickity(".subscription-slider", {
      prevNextButtons: false,
      pageDots: true,
      cellAlign: 'left',
      contain: true
  });
}

// Update Subscription Details
function subscribeFooter(totalQuantity, original, price, saving) {
  var inCart = 0;
  var inCartTotal = 0;
  var inCartSavings = 0;
  document.querySelector('.subscription_add').disabled = true;

  fetch("{{ shop.secure_url }}/cart?view=subscription-count")
    .then(response => response.text())
    .then(res => {
      document.querySelector('.subscription_add').disabled = false;
      var ajaxObj = res.split('-');
      inCart = parseInt(ajaxObj[0]);
      inCartTotal = parseInt(ajaxObj[1]);
      inCartSavings = parseInt(ajaxObj[2]);
      var qRemainingClean = 3 - totalQuantity;

      if (price < 1) {
        price = price + inCartTotal;
      }
      if (saving < 1) {
        saving = saving + inCartSavings;
      }
      if (original < 1) {
        original = original + (price + saving);
      }
      if (totalQuantity < 1) {
        totalQuantity = totalQuantity + inCart;
      }

      document.querySelector('[data-total-quantity]').setAttribute('data-total-quantity', totalQuantity);
      document.getElementById('shopify-section-subscription-collection').querySelector('.subscribe-footer-atc .contents span').innerText = totalQuantity;

      var qRemainingClean = 3 - totalQuantity;

      var itemRemaining;
      var qRemaining = 3 - totalQuantity;
      var subscribeError = document.getElementById('shopify-section-subscription-collection').querySelector('.subscribe-tools .subscribe-error span');
      var subscribeBar = document.getElementById('shopify-section-subscription-collection').querySelector('.mob-fix .subscribe-error span');

      if(qRemainingClean == 3){
        document.querySelector('.add-to-basket').classList.add('disabled');
      }else{
        document.querySelector('.add-to-basket').classList.remove('disabled');
      }
      if(qRemaining == 3){
        itemRemaining = 'three';
        subscribeError.parentElement.style.display = 'block';
        subscribeError.parentElement.previousElementSibling.style.display = 'block';
        subscribeBar.parentElement.classList.remove("success");
      }else if(qRemaining == 2){
        itemRemaining = 'two';
        subscribeError.parentElement.style.display = 'block';
        subscribeError.parentElement.previousElementSibling.style.display = 'block';
        subscribeBar.parentElement.classList.remove("success");
      }else if(qRemaining == 1){
        itemRemaining = 'one';
        subscribeError.parentElement.style.display = 'block';
        subscribeError.parentElement.previousElementSibling.style.display = 'block';
        subscribeBar.parentElement.classList.remove("success");
      }else{
        subscribeError.parentElement.parentElement.classList.add('error-hide');
        subscribeError.parentElement.style.display = 'none';
        subscribeError.parentElement.previousElementSibling.style.display = 'none';
        subscribeBar.parentElement.classList.add("success");
      }
      subscribeBar.innerText = itemRemaining;
      subscribeError.innerText = itemRemaining;

      document.querySelector('.subscribe-footer-steps .subs-number.active').classList.remove('active');
      var subsNumbers = document.querySelectorAll('.subscribe-footer-steps .subs-number');
      for (var i = 0; i < totalQuantity; i++) {
        subsNumbers[i].classList.add('active');
      }

      document.querySelector('.subscribe-footer-totals .subtotal .money').setAttribute('data-amount', original);
      document.querySelector('.subscribe-footer-totals .subtotal .money').innerText = Shopify.formatMoney(original, document.body.getAttribute('data-format'));

      document.querySelector('.subscribe-footer-totals .saving .money').setAttribute('data-amount', saving);
      document.querySelector('.subscribe-footer-totals .saving .money').innerText = '-' + Shopify.formatMoney(saving, document.body.getAttribute('data-format'));

      if (price > 0) {
        document.querySelector('.subscribe-footer-totals .total .free-shipping').classList.add('show');
      } else {
        document.querySelector('.subscribe-footer-totals .total .free-shipping').classList.remove('show');
      }

      document.querySelector('.subscribe-footer-totals .total .money').setAttribute('data-amount', price);
      document.querySelector('.subscribe-footer-totals .total .money').innerText = Shopify.formatMoney(price, document.body.getAttribute('data-format'));
    })
    .catch(error => console.error('Error:', error));
}

// Add to basket click
if(document.getElementById('shopify-section-subscription-collection')){
  document.getElementById('shopify-section-subscription-collection').querySelector('.add-to-basket').addEventListener('click', function() {
    this.classList.add('disabled');
    var defaultLabel = this.querySelector('.button-label').innerText;
    this.querySelector('.button-label').innerText = 'adding...';
    
    var product_array = [];
    document.querySelectorAll('.subscription_product.selected').forEach(function(element) {
        var variantID = element.getAttribute('data-variant');
        var variantQuantity = element.querySelector('.product-quantity__input').value;
        var variantComparePrice = element.querySelector('[data-compare-price]').getAttribute('data-compare-price');
        var item = {
            "variantID": variantID,
            "variantQuantity": variantQuantity,
            "variantComparePrice": variantComparePrice
            // "sellingPlan": sellingPlan
        };
        product_array.push(item);
    });

    document.querySelector('.loading-overlay').classList.add('visible');
    addAllItems(product_array);
  });
}

// Add all items
window.addAllItems = function addAllItems(array) {
    Shopify.queue = [];
    var totalQuantity = 0;
    let quantity = 0;

    if (isNaN(quantity)) {
        quantity = 0;
    }
  
    if (isNaN(totalQuantity)) {
        totalQuantity = 0;
    }
    array.forEach(data => {
        if (data.type === 'one') {
            Shopify.queue.push({
                variantId: data.variantID,
                variantQuantity: data.variantQuantity,
                type: 'one'
            });
        } else {
          console.log('One time variant added to cart');
            const variantBoxes = document.querySelectorAll('.variants-box');
            const hasAdditionalVariants = Array.from(variantBoxes).some(box => {
              const qtyInput = box.querySelector('.qty-numbers');
              return qtyInput && parseInt(qtyInput.value, 10) > 0;
            });
            const groupId = hasAdditionalVariants ? String(Date.now()) : null;

            // When additional variants have qty > 0, add only those—do not add the main product
            if (!hasAdditionalVariants) {
              Shopify.queue.push({
                  variantId: data.variantID,
                  variantQuantity: data.variantQuantity,
                  selling_plan: data.sellingplanid,
                  property: data.property,
                  subscriptionGroupId: groupId
              });
            }

            variantBoxes.forEach(box => {
              const qtyInput = box.querySelector('.qty-numbers');
              if (!qtyInput) return;

              const qty = parseInt(qtyInput.value);
              console.log(qty)
              if(qty > 0){
                const variantId = box.getAttribute('data-variant-id');
                // console.log(variantId);
                if (!variantId) return;
  
                Shopify.queue.push({
                    variantId: variantId,
                    variantQuantity: qty,
                    type: 'one',
                    subscriptionGroupId: groupId
                });
              }

          });
        }
    });
    Shopify.moveAlong = function () {

        if (Shopify.queue.length) {
            const request = Shopify.queue.shift();
            // totalQuantity += parseInt(request.variantQuantity);

            let data;
            // console.log(request.type);
            const groupId = request.subscriptionGroupId || null;
            if (request.type === 'one') { // One-time additional variants: pass "Additional Variant" property (same as Every Month/Quarterly)
                const properties = { "Additional Variant": "True" };
                if (groupId) properties._subscription_group_id = groupId;
                data = {
                    id: Number(request.variantId) || request.variantId,
                    quantity: Number(request.variantQuantity) || request.variantQuantity,
                    properties: properties
                };
            } else { //console.log("else selling ID",request)
                data = {
                    id: request.variantId,
                    quantity: request.variantQuantity,
                    selling_plan: request.selling_plan,
                    properties: {
                      __free_gift: request.property
                    }
                    // properties: {
                    //   shipping_interval_frequency: request.frequency,
                    //   shipping_interval_unit_type: request.unit_type,
                    //   _compare_price: request.compare_price
                    // }
                };
                if (groupId) {
                    data.properties = data.properties || {};
                    data.properties._subscription_group_id = groupId;
                }
            }

            fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
            })
                .then(response => response.json())
                .then((res) => {
                    Shopify.moveAlong();
                    quantity += parseInt(request.variantQuantity);
                })
                .catch(() => {
                    if (Shopify.queue.length) {
                        Shopify.moveAlong();
                    }
                });
        } else {
            defaultCartDrawerUpdate().then(function() {
                setTimeout(function() {
                    if (typeof window.resetAdditionalProductQuantitiesAfterAddToCart === 'function') {
                        window.resetAdditionalProductQuantitiesAfterAddToCart();
                    }
                }, 500);
            });
            // addToCartOk(totalQuantity);
            cartUpdate('basic');
            // resetExpandWidget();
            resetPage();
        }
    }
    Shopify.moveAlong();
}

async function defaultCartDrawerUpdate() {
  try {
    const response = await fetch(`${Shopify.routes.root}cart?section_id=cart-drawer`);
    const responseText = await response.text();
    const html = new DOMParser().parseFromString(responseText, 'text/html');
    const selector = ['cart-drawer'];
    const targetElement = document.querySelector(selector);
    const sourceElement = html.querySelector(selector);
    const isCartEmpty = sourceElement.classList.contains("is-empty");
    isCartEmpty ? targetElement.classList.add("is-empty") : targetElement.classList.remove("is-empty")
    targetElement.innerHTML = sourceElement.innerHTML;
    const res = await fetch(`${Shopify.routes.root}cart?section_id=cart-icon-bubble`);
    const resText = await res.text();
    const icon_bubble_html = new DOMParser().parseFromString(resText, 'text/html');
    const selector_bubble = ['#cart-icon-bubble'];
    const targetElement_bubble = document.querySelector(selector_bubble);
    const sourceElement_bubble = icon_bubble_html.querySelector('#shopify-section-cart-icon-bubble').innerHTML;
    
    if (targetElement_bubble && sourceElement_bubble) {
      targetElement_bubble.innerHTML = sourceElement_bubble;
    }
    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    document.querySelector('#cart-icon-bubble').click();
    // Do not clear variant qtys here - prevents price blink in .sacing and .total_month_saving
  } catch (error) {
    console.error('Error updating cart drawer:', error);
  }
}

window.addEventListener("quizifyAddToCart", function(){
    defaultCartDrawerUpdate();
})

// After all items added
function addToCartOk(quantity) {
    // const addToBasketButton = document.querySelector('#shopify-section-subscription-collection .add-to-basket');
    // const buttonLabel = addToBasketButton.querySelector('.button-label');
  
    // buttonLabel.innerText = 'add subscription to basket';
    // addToBasketButton.classList.remove('disabled');
    cartUpdate('basic');
    cartBubble(quantity);
    resetPage();
}

//Cart Bubble
function cartBubble(quantity) {
  if (quantity > 0) {
    const cartCountBubble = document.querySelector('.cart-count-bubble');

    if (!cartCountBubble) {
      const cartIconBubble = document.querySelector('#cart-icon-bubble');
      const newCartCountBubble = document.createElement('div');
      newCartCountBubble.classList.add('cart-count-bubble');

      const firstSpan = document.createElement('span');
      firstSpan.setAttribute('aria-hidden', 'true');
      newCartCountBubble.appendChild(firstSpan);

      const secondSpan = document.createElement('span');
      secondSpan.classList.add('visually-hidden');
      newCartCountBubble.appendChild(secondSpan);

      cartIconBubble.appendChild(newCartCountBubble);
    }

    const firstSpan = document.querySelector('.cart-count-bubble span:first-child');
    firstSpan.innerText = quantity;

    const secondSpan = document.querySelector('.cart-count-bubble span:last-child');
    if (quantity > 1) {
      secondSpan.innerText = quantity + " items";
    } else {
      secondSpan.innerText = quantity + " item";
    }
  } else {
    const cartCountBubble = document.querySelector('.cart-count-bubble');
    if (cartCountBubble) {
      cartCountBubble.remove();
    }
  }
}

// Update Slideout Cart
async function cartUpdate(type) {
  const response = await fetch("/cart?view=ajax");
  const data = await response.text();
  
  if (response.ok) {
    document.body.classList.add('cart-open');
    const cartPopupInner = document.querySelector('.cart-popup-inner');
    if(cartPopupInner){      
      cartPopupInner.innerHTML = data;
    }
    const cartPopup = document.querySelector('.cart-popup');
    if(cartPopup){
      cartPopup.classList.add('visible');
    }
  
    const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const t = currentScrollTop - 1;
    window.scrollTo({ top: t, behavior: 'smooth' });
  
    const loadingOverlay = document.querySelector('.loading-overlay');
    if(loadingOverlay){loadingOverlay.classList.remove('visible');}
  }
}

/*
document.addEventListener('rebuy:cart.change', (event) => {
  const { cart: { cart: Smartcart} } = event.detail;
  setTimeout(()=>{
    const items = Smartcart.items;
    const allLiItems = document.querySelectorAll('.rebuy-cart__flyout-item');
    
    if (items.length > 0) {
      items.forEach((item, index) => {
        if(!allLiItems[index].hasAttribute('lineitem_sellingId')){        
          allLiItems[index]?.setAttribute('lineitem_sellingId', item?.selling_plan_allocation?.selling_plan?.id);
        }
      });
  
      const allQuarterlySubscriptionLi = document.querySelectorAll('[lineitem_sellingid]');
      if (allQuarterlySubscriptionLi.length > 0) {
        allQuarterlySubscriptionLi.forEach(quarterSubscriptionItem => {
          if(quarterSubscriptionItem?.getAttribute('lineitem_sellingid') === '1473806425'){          
            const quantityButtons = quarterSubscriptionItem?.querySelector('.rebuy-cart__flyout-item-quantity-widget')?.querySelectorAll('button');
            if(quantityButtons.length > 0){quantityButtons.forEach(button=> button.classList.add('hidden'))};
          }
        });
      }
    }
    const cartDrawerAnnouncementBar = document.querySelector('.rebuy-cart__flyout-announcement-bar-message');
    if(cartDrawerAnnouncementBar){    
      if(Smartcart.item_count === 0){
        cartDrawerAnnouncementBar.innerHTML = window.theme.cart_announcement_bar.cart_empty;
      } else if(Smartcart.item_count === 1){
        cartDrawerAnnouncementBar.innerHTML = window.theme.cart_announcement_bar.one_product_in_cart;
      } else if(Smartcart.item_count === 2){
        cartDrawerAnnouncementBar.innerHTML = window.theme.cart_announcement_bar.two_products_in_cart;   
      } else if(Smartcart.item_count > 2){
        cartDrawerAnnouncementBar.innerHTML = window.theme.cart_announcement_bar.three_products_or_more_in_cart;   
      }
    }
    if(document.querySelector('.cart-count-bubble span:first-child')){
      document.querySelector('.cart-count-bubble span:first-child').innerText = Smartcart.item_count;
    }  
  }, 100);
});
*/


// Reset page after add to basket
function resetPage() {

  const subscriptionLinkButtons = document.querySelectorAll('.subscription-link .subscribe-button');
  subscriptionLinkButtons.forEach(subscriptionLinkButton => {
    if(subscriptionLinkButton.classList.contains('custom-loading')){
      subscriptionLinkButton.classList.remove('custom-loading');
    }
  });

  const productGridForms = document.querySelectorAll('product-grid-form [type="submit"]');
    productGridForms.forEach(productGridForm => {
    if(productGridForm.classList.contains('custom-loading')){
        productGridForm.classList.remove('custom-loading');
    }
  });
  
  const productQuantityElements = document.querySelectorAll('#shopify-section-subscription-collection .product-quantity');
  productQuantityElements.forEach(productQuantityElement => {
    if(productQuantityElement){
      productQuantityElement.classList.remove('show');
    }
  });

  const subscriptionAddElements = document.querySelectorAll('.subscription_add');
  subscriptionAddElements.forEach(subscriptionAddElement => {
    if(subscriptionAddElement){
      subscriptionAddElement.classList.remove('added');
      const amountElement = subscriptionAddElement.querySelector('.amount');
      amountElement.innerText = '';
      const labelElement = subscriptionAddElement.querySelector('.label');
      labelElement.innerText = '&nbsp;add.';
  
      if (subscriptionAddElement.hasAttribute('disabled')) {
        const labelElement = subscriptionAddElement.querySelector('.label');
        labelElement.innerText = '&nbsp;soldout.';
      }
    }
  });

  const subscriptionProductElements = document.querySelectorAll('.subscription_product');
  subscriptionProductElements.forEach(subscriptionProductElement => {
    if(subscriptionProductElement){
      subscriptionProductElement.classList.remove('selected');
      const productQuantityInputElement = subscriptionProductElement.querySelector('.product-quantity__input');
      productQuantityInputElement.value = 1;
    }
  });

  const totalQuantityElement = document.querySelector('[data-total-quantity]');
  if(totalQuantityElement){
    totalQuantityElement.setAttribute('data-total-quantity', 0);
  }

  const subscribeFooterAtcElement = document.querySelector('.subscribe-footer-atc .contents span');
  if(subscribeFooterAtcElement){
    subscribeFooterAtcElement.innerText = '0';
  }

  
}
if (document.querySelector('#subscription-collection')) {
  resetPage();
}
document.addEventListener('click', function(event) {
  if (event.target.matches('.cart-item-remove')) {
    document.querySelector('.loading-overlay').classList.add('visible');
    const t = event.target;
    const updates = {};
    const variantId = t.closest('.cart-popup-item').getAttribute('data-key');
    const removingQuantity = parseInt(t.closest('.cart-popup-item').querySelector('.item-quantity').innerText);
    const quantity = parseInt(document.querySelector('.cart-count-bubble span:first-child').innerText) - removingQuantity;

    updates[variantId] = 0;
    const data = {updates};

    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
      .then(response => response.json())
      .then(data => {
        cartUpdate();
        cartBubble(quantity);

        if (document.querySelector('#subscription-collection')) {
          const variantIDonly = variantId.split(':');
          const newQty = parseInt(document.querySelector('.subscription_product[data-variant="' + variantIDonly[0] + '"]').getAttribute('data-quantity')) - removingQuantity;
          document.querySelector('.subscription_product[data-variant="' + variantIDonly[0] + '"]').classList.remove('in-cart').setAttribute('data-quantity', newQty);

          const totalQuantity = parseInt(document.querySelector('[data-total-quantity]').getAttribute('data-total-quantity')) - removingQuantity;
          const line_total_original = parseInt(document.querySelector('.subscription_product[data-variant="' + variantIDonly[0] + '"]').querySelector('[data-compare-price]').getAttribute('data-compare-price')) * removingQuantity;
          const original = parseInt(document.querySelector('.subscribe-footer-totals .subtotal .money').getAttribute('data-amount')) - line_total_original;
          const line_total_price = parseInt(document.querySelector('.subscription_product[data-variant="' + variantIDonly[0] + '"]').querySelector('[data-price]').getAttribute('data-price')) * removingQuantity;
          const price = parseInt(document.querySelector('.subscribe-footer-totals .total .money').getAttribute('data-amount')) - line_total_price;
          const saving = original - price;
          subscribeFooter(totalQuantity, original, price, saving);
        }
      })
      .catch(error => console.error('Error:', error));
  }
});
  
document.addEventListener('click', function(e) {
  if (e.target.matches('.header__icon--cart')) {
    e.preventDefault();
    if(document.querySelector('.cart-popup')) {
      document.querySelector('.cart-popup').classList.toggle('visible')
    }
    document.body.classList.add('cart-open');
  }
});

window.addEventListener('resize', function() {
  cartPopupPos();
});

// Product Free Gift Logic
async function fetchCart() {
  const response = await fetch(`${window.Shopify.routes.root}cart.js`);
  const responseData = await response.json();
  return responseData;
}

async function handleSubscribeAddToCart({ currentTarget }) { 
  // Add loading class
  currentTarget.classList.add("custom-loading");

  // Fetch latest snapshot of cart
  const cartJson = await fetchCart();

  const itemsArray = [];
  // Get data from attributes
  const variantId = currentTarget.getAttribute("data-variant");
  const freeGiftVariantId = currentTarget.getAttribute("data-free-gift-id");
  const cartHasGiftProduct = cartJson.items.find((item) => item.id == freeGiftVariantId);

  // Cart drawer promotional product: add only the promo variant, no selling plan, no additional variants
  const isPromotionalProduct = currentTarget.classList.contains('promotional_product') || currentTarget.closest('.cart_promotion_banner');
  if (isPromotionalProduct && variantId) {
    const promoItem = { id: variantId, quantity: 1, properties: {} };
    const headers = { method: "POST", headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [promoItem] }) };
    const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, headers);
    const data = await response.json();
    currentTarget.classList.remove("custom-loading");
    if (data.status) {
      console.error('Cart add error (promotional):', data);
      alert(data.description || 'Error adding promotional item to cart');
      return;
    }
    defaultCartDrawerUpdate();
    return;
  }

  // When a radio with class select-plan is checked: "ships every 30 days" -> data-sellingplanid, "ships every 90 days" -> data-quater-id
  const checkedPlanRadio = document.querySelector('input.select-plan:checked');
  const planLabel = checkedPlanRadio ? checkedPlanRadio.getAttribute('data-label') : '';
  const planLabelLower = (planLabel || '').toLowerCase().trim();
  // Detect quarterly (90 days) and monthly (30 days); fallback to label containing "90" / "30"
  const is90Days = planLabelLower === 'ships every 90 days' || (planLabelLower.indexOf('90') !== -1 && planLabelLower.indexOf('30') === -1);
  const is30Days = planLabelLower === 'ships every 30 days' || (planLabelLower.indexOf('30') !== -1 && !is90Days);

  console.log('Plan selection:', { planLabel, planLabelLower, is30Days, is90Days });
  
  // Get the selling plan ID from the button in the same container as the checked radio
  // This ensures we get the correct plan ID even if multiple buttons exist
  let sellingPlanId = null;
  if (checkedPlanRadio) {
    const planContainer = checkedPlanRadio.closest('.collapsible-button');
    if (planContainer) {
      const buttonInContainer = planContainer.querySelector('.subscribe-button');
      if (buttonInContainer) {
        if (is30Days) {
          sellingPlanId = buttonInContainer.getAttribute("data-sellingplanid");
        } else if (is90Days) {
          sellingPlanId = buttonInContainer.getAttribute("data-quater-id");
        } else {
          sellingPlanId = buttonInContainer.getAttribute("data-sellingplanid") || buttonInContainer.getAttribute("data-quater-id");
        }
      }
    }
  }
  
  // Fallback to currentTarget if we didn't find it in the container
  if (!sellingPlanId) {
    if (is30Days) {
      sellingPlanId = currentTarget.getAttribute("data-sellingplanid");
    } else if (is90Days) {
      sellingPlanId = currentTarget.getAttribute("data-quater-id");
    } else {
      sellingPlanId = currentTarget.getAttribute("data-sellingplanid") || currentTarget.getAttribute("data-quater-id");
    }
  }
  
  console.log('Main product selling plan ID:', sellingPlanId);

  // Every 3 months (quarterly): main product quantity = 3. Every month or one-time: use custom-quantity or 1
  let quantity = 1;
  if (is90Days) {
    quantity = 3;
  } else if (currentTarget.hasAttribute('custom-quantity')) {
    quantity = parseInt(currentTarget.getAttribute('custom-quantity'), 10) || 1;
  }
  const uniqueId = new Date().getTime();

  // When additional variants have qty > 0, add only those—do not add/update the main product
  const variantBoxesCheck = document.querySelectorAll('.variants-box');
  const hasAdditionalVariantsWithQty = Array.from(variantBoxesCheck).some(box => {
    const qtyInput = box.querySelector('.qty-numbers');
    return qtyInput && (parseInt(qtyInput.value, 10) || 0) > 0;
  });

  const itemsToAdd = [];
  const itemsToUpdate = [];
  let mainProductItem = null;
  let mainProductNeedsUpdate = false;

  if (!hasAdditionalVariantsWithQty) {
    // Check if main product with same variant and selling plan already exists in cart
    const existingMainCartItem = cartJson.items.find(item => {
      if (String(item.variant_id) !== String(variantId)) return false;
      const itemSellingPlanId = item.selling_plan_allocation?.selling_plan?.id;
      if (sellingPlanId) {
        if (!itemSellingPlanId || String(itemSellingPlanId) !== String(sellingPlanId)) return false;
      } else {
        if (itemSellingPlanId) return false;
      }
      return true;
    });

    if (existingMainCartItem) {
      const newQuantity = existingMainCartItem.quantity + quantity;
      itemsToUpdate.push({ id: existingMainCartItem.key, quantity: newQuantity });
      mainProductNeedsUpdate = true;
      mainProductItem = { id: variantId, selling_plan: sellingPlanId, quantity: quantity, properties: {} };
    } else {
      mainProductItem = { id: variantId, selling_plan: sellingPlanId, quantity: quantity, properties: {} };
      itemsArray.push(mainProductItem);
    }

    if (freeGiftVariantId && !cartHasGiftProduct) {
      const freeGiftItem = { id: freeGiftVariantId, quantity: 1, properties: { _custom_free_gift_id: uniqueId } };
      if (mainProductItem) mainProductItem.properties["_custom_free_gift"] = uniqueId;
      itemsArray.push(freeGiftItem);
    }
  }

  let hasAdditionalVariants = false;
  const variantBoxes = document.querySelectorAll('.variants-box');
  
  variantBoxes.forEach(box => {
    const qtyInput = box.querySelector('.qty-numbers');
    if (!qtyInput) return;

    const inputQty = parseInt(qtyInput.value, 10) || 0;
    if (inputQty <= 0) return;
    // Every 3 months (quarterly): each additional variant sends quantity 3. Every month or one-time: use input value
    const qty = is90Days ? 3 : inputQty;

    const extraVariantId = box.getAttribute('data-variant-id');
    if (!extraVariantId) return;

    if (extraVariantId == variantId) return;

    let extraSellingPlanId = null;
    if (is30Days) {
      extraSellingPlanId = box.getAttribute('data-sellingplanid');
    } else if (is90Days) {
      extraSellingPlanId = box.getAttribute('data-quater-id');
    } else {
      extraSellingPlanId = box.getAttribute('data-sellingplanid') || box.getAttribute('data-quater-id');
    }

    // Check if this variant with the same selling plan already exists in cart
    const existingCartItem = cartJson.items.find(item => {
      // Match by variant ID
      if (String(item.variant_id) !== String(extraVariantId)) return false;
      
      // Match by selling plan ID
      const itemSellingPlanId = item.selling_plan_allocation?.selling_plan?.id;
      if (extraSellingPlanId) {
        // If we have a selling plan, the cart item must have the same one
        if (!itemSellingPlanId || String(itemSellingPlanId) !== String(extraSellingPlanId)) {
          return false;
        }
      } else {
        // If we don't have a selling plan, the cart item shouldn't have one either
        if (itemSellingPlanId) return false;
      }
      
      return true;
    });

    if (existingCartItem) {
      // Item exists with same variant and plan - update quantity
      const newQuantity = existingCartItem.quantity + qty;
      itemsToUpdate.push({
        id: existingCartItem.key,
        quantity: newQuantity
      });
    } else {
      // New item - add to cart
      const extraItem = { id: extraVariantId, quantity: qty, properties: {} };
      if (extraSellingPlanId) extraItem.selling_plan = extraSellingPlanId;
      // Add property to identify this as an additional variant for display in cart
      extraItem.properties["Additional Variant"] = "True";
      itemsToAdd.push(extraItem);
    }
    
    hasAdditionalVariants = true;
  });
  
  // Add new items to itemsArray
  itemsArray.push(...itemsToAdd);

  // When we have additional variants, link main + additional items with same timestamp so removing main removes all
  // Note: If main product is being updated, we can't add properties to it via update API, so grouping only applies to new items
  if (hasAdditionalVariants && !mainProductNeedsUpdate) {
    const groupId = String(uniqueId);
    if (mainProductItem) {
      mainProductItem.properties["_subscription_group_id"] = groupId;
    }
    itemsArray.forEach(function(item) {
      if (item !== mainProductItem && String(item.id) !== String(freeGiftVariantId)) {
        if (!item.properties) item.properties = {};
        item.properties["_subscription_group_id"] = groupId;
      }
    });
  }

  // Debug: log what we're trying to add/update
  console.log('Adding items to cart:', itemsArray);
  console.log('Updating existing items:', itemsToUpdate);
  
  // First, update existing items if any
  if (itemsToUpdate.length > 0) {
    const updates = {};
    itemsToUpdate.forEach(item => {
      updates[item.id] = item.quantity;
    });
    
    const updateHeaders = { method: "POST", headers: {'Content-Type': 'application/json'}, body: JSON.stringify({updates}) };
    const updateResponse = await fetch(`${window.Shopify.routes.root}cart/update.js`, updateHeaders);
    const updateData = await updateResponse.json();
    
    // Check for errors
    if (updateData.status) {
      console.error('Cart update error:', updateData);
      alert(updateData.description || 'Error updating cart items');
      currentTarget.classList.remove("custom-loading");
      return;
    }
  }
  
  // Then, add new items if any
  if (itemsArray.length > 0) {
    const headers = { method: "POST", headers: {'Content-Type': 'application/json'}, body: JSON.stringify({items: itemsArray}) };
    const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, headers);
    const data = await response.json();
    
    // Check for errors
    if (data.status) {
      console.error('Cart add error:', data);
      alert(data.description || 'Error adding items to cart');
      currentTarget.classList.remove("custom-loading");
      return;
    }
  }
  
  currentTarget.classList.remove("custom-loading");
  const closestSubscription = currentTarget.closest('.card_product_subscription');
  console.log('Items added/updated to cart [Subscription]');
  // resetExpandWidget();
  defaultCartDrawerUpdate().then(function() {
    setTimeout(function() {
      if (typeof window.resetAdditionalProductQuantitiesAfterAddToCart === 'function') {
        window.resetAdditionalProductQuantitiesAfterAddToCart();
      }
    }, 500);
  });
  // Keep sacing/total_month_saving showing actual calculated total (main + variants)
  if (typeof window.updateSubscriptionPrices === 'function') {
    window.updateSubscriptionPrices();
  }
}

const productSubscribeButtons = Array.from(document.querySelectorAll(".subscribe-button"));
if(productSubscribeButtons.length) {
  productSubscribeButtons.forEach((productSubscribeButton)=> productSubscribeButton.addEventListener("click", handleSubscribeAddToCart.bind(this), true));
}

// Cart Subscriptions Logic - change monthly plan to quarterly (same line item, update selling_plan via cart/change.js)
async function upgradeToQuarterlySubscription(event) {
  const currentTarget = event && (event.currentTarget || event.target);
  const subscriptionCover = currentTarget && currentTarget.closest(".subscription__cover");
  if (!subscriptionCover) return;

  const oldLineItemEl = subscriptionCover.querySelector('.old_lineItem_id');
  const lineItemKey = oldLineItemEl ? oldLineItemEl.getAttribute('data-old-lineitem-id') : null;
  const quantityEl = subscriptionCover.querySelector('.lineItem_quantity');
  const lineItemIdEl = subscriptionCover.querySelector('.lineItem_id');
  const variantIdForAdd = lineItemIdEl ? lineItemIdEl.getAttribute('data-lineitem-id') : null;
  const quantity = quantityEl ? quantityEl.getAttribute('data-lineitem-quantity') : '1';
  const sellingIdEl = subscriptionCover.querySelector('.selling_id');
  const newSellingPlanId = sellingIdEl ? sellingIdEl.getAttribute('data-selling-id') : null;

  if (!lineItemKey || !newSellingPlanId) {
    console.error('upgradeToQuarterlySubscription: missing lineItemKey or selling plan id');
    return;
  }

  const cartJson = await fetchCart();
  const itemIndex = cartJson.items.findIndex(function(item) { return String(item.key) === String(lineItemKey); });
  if (itemIndex === -1) {
    console.error('upgradeToQuarterlySubscription: line item not found in cart');
    return;
  }
  const cartItem = cartJson.items[itemIndex];
  const properties = (cartItem && cartItem.properties) ? cartItem.properties : {};
  const line = itemIndex + 1;
  const quarterlyQuantity = 3;

  const updates = {
    line: line,
    quantity: quarterlyQuantity,
    selling_plan: Number(newSellingPlanId),
    properties: properties
  };

  const changeHeaders = { method: "POST", headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(updates) };
  const response = await fetch(`${window.Shopify.routes.root}cart/change.js`, changeHeaders);
  const data = await response.json();
  
  if (data && data.status && data.status !== 200) {
     // Fallback for main product: cart/change can fail with "Cannot apply selling plan to variant". Remove line and re-add with correct variant + selling plan.
    const useFallback = (data.status === 422 && data.description && data.description.indexOf('selling plan') !== -1) || data.status !== 200;
    if (useFallback) {
      const variantId = (variantIdForAdd && variantIdForAdd.trim() !== '') ? Number(variantIdForAdd) : cartItem.id;
      const removePayload = { id: lineItemKey, quantity: 0 };
      const removeRes = await fetch(`${window.Shopify.routes.root}cart/change.js`, {
        method: "POST",
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(removePayload)
      });
      const removeData = await removeRes.json();
      if (removeData && removeData.status && removeData.status !== 200) {
        console.error('Cart remove error:', removeData);
        if (removeData.description) alert(removeData.description);
        return;
      }
      const addPayload = {
        id: variantId,
        quantity: quarterlyQuantity,
        selling_plan: Number(newSellingPlanId),
        properties: properties
      };
      const addRes = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: "POST",
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(addPayload)
      });
      const addData = await addRes.json();
      if (addData && addData.status && addData.status !== 200) {
        console.error('Cart add error:', addData);
        if (addData.description) alert(addData.description);
        return;
      }
      defaultCartDrawerUpdate();
      return;
    }
    console.error('Cart change error:', data);
    if (data.description) alert(data.description);
    return;
  }

  defaultCartDrawerUpdate();
}

async function upgradeToSubscription({ currentTarget }) {
  const subscriptionCover = currentTarget.closest(".subscription__cover");
  if(!subscriptionCover) return;

  const cartJson = await fetchCart();
  const freeGiftVariantId = currentTarget.getAttribute('data-free-gift-id');
  const cartHasGiftProduct = cartJson.items.find((item) => item.id == freeGiftVariantId);
  const uniqueId = new Date().getTime();

  if(!cartHasGiftProduct){    
    if(freeGiftVariantId){
      const freeGiftItem = { id: Number(freeGiftVariantId), quantity: 1, properties: { _custom_free_gift_id: uniqueId } };
      const headers = { method: "POST", headers: {'Content-Type': 'application/json'}, body: JSON.stringify(freeGiftItem) };
      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, headers);
      const data = await response.json();
    }
  }
  
  const quantity = subscriptionCover.querySelector('.lineItem_quantity').getAttribute('data-lineitem-quantity');
  const oldVariantId = subscriptionCover.querySelector('.old_lineItem_id').getAttribute('data-old-lineitem-id');
  const sellingPlanId = subscriptionCover.querySelector('.selling_id').getAttribute('data-selling-id');
  const cartItem = cartJson.items.find(function (item) { return String(item.id) === String(oldVariantId) || String(item.key) === String(oldVariantId); });
  const existingProperties = (cartItem && cartItem.properties) ? Object.assign({}, cartItem.properties) : {};
  const properties = Object.assign({}, existingProperties, { _custom_free_gift: uniqueId });
  let updates = { id: oldVariantId, quantity: 0 };
  const updateHeaders = { method: "POST", headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(updates) };
  const response =  await fetch(`${window.Shopify.routes.root}cart/change.js`, updateHeaders);
  const data = await response.json();
  const newVariantId = subscriptionCover.querySelector('.lineItem_id').getAttribute('data-lineitem-id');
  const addPayload = {
    id: newVariantId,
    quantity: quantity,
    selling_plan: Number(sellingPlanId),
    properties: properties
  };
  const addRes = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
    method: "POST",
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(addPayload)
  });
  const addData = await addRes.json();
  if (addData && addData.status && addData.status !== 200) {
    console.error('Cart add error:', addData);
    if (addData.description) alert(addData.description);
    return;
  }
  defaultCartDrawerUpdate();
}

document.querySelectorAll('product-grid-form form').forEach(form => {
  form.addEventListener('submit', e => {
    e.preventDefault();
    const submitButton = form.querySelector('[type="submit"]');
    submitButton.classList.add('custom-loading');
    const variantID = form.querySelector('[name="id"]').value;
    const productArray = [
      {
        variantID,
        variantQuantity: 1         
      }
    ];
      addAllItems(productArray);
    });
  });

document.addEventListener("DOMContentLoaded", () => {
  const Widget_Main_divs = document.querySelectorAll('.widget_button');
  Widget_Main_divs.forEach(function(widget_div){
    const Collapsible_Buttons = widget_div.querySelectorAll('.collapsible-button');
    Collapsible_Buttons.forEach(function(button){
      button.addEventListener('click', function(el){
        // console.log(button);
        const inputCheck = button.querySelector('.title-label input');
        Collapsible_Buttons.forEach(function(button){
          button.classList.remove('active');
        });
        if(!button.classList.contains('active')){
          button.classList.add('active');
        }
        inputCheck.checked = true;
        
          var Saving_value = '';
          var total_value = '';
          var saving_text = '';
          const Activated_button = widget_div?.querySelector('.collapsible_subscription_main.active');
          const subscription_text_footer = widget_div?.querySelector('.subscription__text_footer');
          const subscription_text_html = Activated_button?.querySelector('.subscription__text')?.innerHTML;
          if(Activated_button){
            Saving_value = Activated_button.getAttribute('data-saving-value');
            total_value = Activated_button.getAttribute('data-total-value');
            saving_text = Activated_button.getAttribute('data-saving-text');
          }
          const collapsible_button_total_wrp = widget_div?.querySelector('.collapsible_button_total_wrp');
          if(collapsible_button_total_wrp){
            const moneyFormat = document.body.getAttribute('data-format') || Shopify.money_format;
            const formatMoneyValue = function(val, allowNegative) {
              if (val == null || val === '') return val;
              var str = String(val).trim();
              var isNegative = allowNegative && str.indexOf('-') === 0;
              if (isNegative) str = str.replace(/^-/, '').trim();
              if (!allowNegative) {
                if (str.indexOf('-') === 0) str = str.replace(/^-/, '').trim();
                str = str.replace(/([£€$])-\s*/g, '$1');
              }
              if (/[£€$]/.test(str)) return (isNegative ? '-' : '') + str;
              var num = parseFloat(str.replace(/[^\d.]/g, '')) || 0;
              var cents = Math.round(num * 100);
              var formatted = typeof Shopify.formatMoney === 'function' ? Shopify.formatMoney(cents, moneyFormat) : str;
              return (isNegative ? '-' : '') + formatted;
            };
            const savingEle = collapsible_button_total_wrp.querySelector('.sacing');
            if(savingEle){
              savingEle.querySelectorAll('span')[1].innerText = formatMoneyValue(Saving_value, false);
            }
            const totalEle = collapsible_button_total_wrp.querySelector('.sacing.total_month_saving');
            if(totalEle){
              totalEle.querySelectorAll('span')[1].innerText = formatMoneyValue(total_value, false);
              totalEle.querySelectorAll('span')[0].innerText = saving_text;
            }
          }
          // Recalculate total (main + variants) so sacing/total_month_saving show actual total when variant qtys > 0
          if (typeof window.updateSubscriptionPrices === 'function') {
            window.updateSubscriptionPrices();
          }
          if(subscription_text_footer && subscription_text_html){
            subscription_text_footer.innerHTML = subscription_text_html;
          }else{
            if(subscription_text_footer) subscription_text_footer.innerHTML='';
          }
      });
    });
  });

   function normalizeSavingDisplay() {
    document.querySelectorAll('.collapsible_button_total_wrp').forEach(function(wrp) {
      const savingEle = wrp.querySelector('.sacing:not(.total_month_saving)');
      if (!savingEle) return;
      const span = savingEle.querySelectorAll('span')[1];
      if (!span || !span.textContent) return;
      var t = span.textContent.trim();
      if (/[£€$]-\s*[\d.,]/.test(t)) span.textContent = t.replace(/([£€$])-\s*/g, '$1');
    });
  }
  normalizeSavingDisplay();
  
});

document.addEventListener("DOMContentLoaded", () => {
  const AllCollapse_add_buttons = document.querySelectorAll('.collapsible-add-button');
  if(AllCollapse_add_buttons.length > 0){
    AllCollapse_add_buttons.forEach(button=> button.addEventListener('click', triggerRelatedButton.bind(this)));
  }
  
  // const AllCollapse_expand_buttons = document.querySelectorAll('.collapsible-expand-button');
  // if(AllCollapse_expand_buttons.length > 0){
  //   AllCollapse_expand_buttons.forEach(expanded_button=> expanded_button.addEventListener('click', expand_widget.bind(this)));
  // }
});

function resetExpandWidget(){
  const All_card_product_subscriptions = document.querySelectorAll('.card_product_subscription');
  if(All_card_product_subscriptions.length > 0){
    All_card_product_subscriptions.forEach(card_product_subscription=>{
      if(card_product_subscription){
        const nearestLi = card_product_subscription?.closest('li');
        const widget_button = card_product_subscription?.querySelector('.widget_button');
        const collapsible_expand_button = card_product_subscription?.querySelector('.collapsible-expand-button')?.querySelector('button');
        if(collapsible_expand_button && collapsible_expand_button.hasAttribute('hidden')) collapsible_expand_button.removeAttribute('hidden');
        if(widget_button && widget_button.classList.contains('widget-expanded')) widget_button.classList.remove('widget-expanded');
        if(nearestLi && nearestLi.classList.contains('js-widget-expanded')) nearestLi.classList.remove('js-widget-expanded');
      }
    })
  }
}

function expand_widget(event){
  const _this = event.target;
  const nearestLi = _this?.closest('li');
  const nearestEle = _this?.closest('.card_product_subscription');
  if(nearestEle && nearestLi){
    const widgetEle = nearestEle?.querySelector('.widget_button');
    if(nearestLi) nearestLi.classList.add('js-widget-expanded');
    if(widgetEle) widgetEle.classList.add('widget-expanded');
    _this.setAttribute('hidden', true);
  }
}

function triggerRelatedButton(event){  
  const _this = event.target;
  const innerButton = _this.querySelector('button');
  innerButton.classList.add('custom-loading');
  const closestMainEle = _this?.closest('.card_product_subscription');
  const activatedOption = closestMainEle?.querySelector('.collapsible-button.collapsible_subscription_main.active');
  if(activatedOption.classList.contains('collapsible-button__subscription')){
    const subsLink = activatedOption?.querySelector('.subscription-link')?.querySelector('a');
    if(subsLink) subsLink.click();
    const monthlyButton = activatedOption?.querySelector('.subscription-link')?.querySelector('button');
    if(monthlyButton) monthlyButton.click();
    setTimeout(()=>{innerButton.classList.remove('custom-loading')}, 1000);
  }else{
    const oneTimeAddButton = activatedOption?.querySelector('.one-time-add-button');
    if(oneTimeAddButton){
      const ATCbutton = oneTimeAddButton.querySelector('button[name="add"]');
      if(ATCbutton) ATCbutton.click();
      setTimeout(()=>{innerButton.classList.remove('custom-loading')}, 1000);
    }
  }
}


let tabs = document.querySelectorAll('.tab');
let tabContents = document.querySelectorAll('.tabContent');
if(document.getElementById('tabs')){
  document.getElementById('tabs').addEventListener('click', function (event) {
    let target = event.target;
    
    if (target.classList.contains('tab')) {
        tabs.forEach((tab, index) => {
            if (tab === target) {
                hideTabsContent(0);
                tab.classList.add('whiteborder');
                tabContents[index].classList.remove('hide');
                tabContents[index].classList.add('show');
            }
        });
    }
});
}

function hideTabsContent(startIndex) {
    for (let i = startIndex; i < tabContents.length; i++) {
        tabContents[i].classList.remove('show');
        tabContents[i].classList.add('hide');
        tabs[i].classList.remove('whiteborder');
    }
}

function toggleAccordion(sectionId, button) {
    var content = document.getElementById(sectionId);

    if (content.style.height === '0px' || content.style.height === '') {
        content.style.height = content.scrollHeight + 'px';
        button.classList.add("activeButton");
    } else {
        content.style.height = '0px';
        button.classList.remove("activeButton");
    }
  }

document.querySelector(".loginopen-popup").addEventListener("click", function() {
  var loginElement = document.getElementById("loginpopup");
  document.querySelector("html").classList.add('overflow-hidden');
  loginElement.classList.toggle("show");
});

document.querySelector(".closepopup").addEventListener("click", function() {
  var loginElement = document.getElementById("loginpopup");
  document.querySelector("html").classList.remove('overflow-hidden');
  loginElement.classList.remove("show");
});


// Brandbassador/Club functionality 
function openClubPopup(){
  const allTheManualButtons = document.querySelectorAll('.js-brand_bassadorion-custom-button');
  if(allTheManualButtons.length > 0){
    const club_widget_ele = document.querySelector('.js-club-widget-ele')?.querySelector('button');
    allTheManualButtons.forEach(button=>{
      if(club_widget_ele){
        clearTimeout(setTimeoutOnele);
        button.addEventListener('click',()=>{
          club_widget_ele.click();
        })
      }
    })
  }
}

const setTimeoutOnele = setTimeout(openClubPopup, 300);

if(document.getElementById("countdown")){
  if(document.querySelector('.countdown_main').getAttribute('date-reset') == "everyday"){
    // Update the countdown every 1 second
    var countdownInterval = setInterval(function() {
        // Get the current date and time
        var now = new Date().getTime();
    
        // Calculate the end time for the day (midnight of the next day)
        var endOfDay = new Date();
        endOfDay.setHours(24, 0, 0, 0); // Set the time to midnight of the next day
        var endOfDayTime = endOfDay.getTime();
    
        // Calculate the distance between now and the end time
        var distance = endOfDayTime - now;
    
        // Calculate hours, minutes, and seconds from the distance
        var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((distance % (1000 * 60)) / 1000);
    
        // Display the countdown timer
        var timerElement = document.getElementById("countdown");
        timerElement.innerHTML = "<div><div>" + hours + "</div><span>hour(s)</span></div><div><div>" + minutes + "</div><span>minute(s)</span></div><div><div>" + seconds + "</div><span>second(s)</span></div>";
    
        // If the countdown is over (at the end of the day)
        if (distance <= 0) {
            // Clear the countdown interval
            clearInterval(countdownInterval);
            
            // Restart the countdown interval to count down to the next day's end time
            countdownInterval = setInterval(arguments.callee, 1000);
        }
    }, 0);
  } else {
    if(document.querySelector('.countdown_main').getAttribute('date-reset') == "specific_day"){
      // Set the date we're counting down to
      var TimerDate = document.getElementById("countdown").getAttribute("data-timer");
      console.log(TimerDate)
      var countDownDate = new Date(TimerDate).getTime();
      
      // Update the count down every 1 second
      var x = setInterval(function() {
      
        // Get today's date and time
        var now = new Date().getTime();
          
        // Find the distance between now and the count down date
        var distance = countDownDate - now;
        
        // Time calculations for days, hours, minutes and seconds
        var days = Math.floor(distance / (1000 * 60 * 60 * 24));
        var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((distance % (1000 * 60)) / 1000);
        
        // Output the result in an element with id="countdown"
        if(days > 0) {      
          document.getElementById("countdown").innerHTML ="<div> <div>" + days + "</div><span>day(s)</span></div><div> <div>" + hours + "</div><span>hour(s)</span></div> <div> <div>" +  minutes + "</div><span>minute(s)</span></div><div> <div>" + seconds + "</div><span>seconds(s)</span></div>";
        } else{      
          document.getElementById("countdown").innerHTML ="<div> <div>" + hours + "</div><span>hour(s)</span></div> <div> <div>" +  minutes + "</div><span>minute(s)</span></div><div> <div>" + seconds + "</div><span>seconds(s)</span></div>";
        }
          
        // If the count down is over, write some text 
        if (distance < 0) {
          clearInterval(x);
          document.getElementById("countdown").innerHTML = "EXPIRED";
          setTimeout(()=>{document.querySelector('.countdown_sticky').style.display = "none";},500);
          document.body.style.setProperty('--counter-height', '0');
        }else{
          document.querySelector(".countdown_sticky").classList.remove("hidden");
        }
      }, 0);
    }
  }
}

// slick slider
if($('.cs-slider-init').length){
    $('.cs-slider-init').slick({
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: false,
      centerPadding: '10px',
      dots:true
    });
  }

// new-bundle-product-template image slider
var mySwiper = new Swiper('.bundle-product-media-list-desktop', {
  slidesPerView: 1,
  centeredSlides: true,
  pagination: {
      el: '.swiper-pagination',
      clickable: true,
      dynamicBullets: true
  }, 
  fadeEffect: {
      crossFade: true
  }
});
var mySwiper_mobile = new Swiper('.bundle-product-media-list-mobile', {
  slidesPerView: 1,
  centeredSlides: true,
  pagination: {
      el: '.swiper-pagination-mobile',
      clickable: true,
      dynamicBullets: true
  }, 
  fadeEffect: {
      crossFade: true
  }
});

// hydration-product-template image slider
var mySwiper = new Swiper('.hydration-product.bundle-product-media-list-desktop', {
  slidesPerView: 1,
  centeredSlides: true,
  loop: true,

  autoplay: {
    delay: 3000,
    disableOnInteraction: false
  },

  pagination: {
    el: '.swiper-pagination',
    clickable: true,
    dynamicBullets: true
  },

  fadeEffect: {
    crossFade: true
  }
});

var mySwiper_mobile = new Swiper('.hydration-product.bundle-product-media-list-mobile', {
  slidesPerView: 1,
  centeredSlides: true,
  loop: true,

  autoplay: {
    delay: 3000,
    disableOnInteraction: false
  },

  pagination: {
    el: '.swiper-pagination-mobile',
    clickable: true,
    dynamicBullets: true
  },

  fadeEffect: {
    crossFade: true
  }
});

const mainSlider = new Swiper(".mySwiper-main", {
  pagination: {
    el: ".swiper-pagination-main",
    clickable: true,
  },
});



const swiperMeta = new Swiper(".mySwiper-meta", {
  autoplay: {
    delay: 3000, // 3 seconds
    disableOnInteraction: false,
  },
  pagination: {
    el: ".swiper-pagination-meta",
  },
});



document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.more,.less').forEach(button => {
    button.addEventListener('click', function () {

      const parentCard = this.closest('.product-body-details-column');

      if (!parentCard) return;

      parentCard.classList.toggle('active');

    });
  });
});


